import React from 'react'
import { useParams } from 'react-router'
import { StatusCategory } from '_gql'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import Divider from '@sputnik/components/Divider'
import { useGetCreditApplicationDetailsSuspenseQuery } from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/GetCreditApplicationDetails.gql'

import ActionsNeededSection from './ActionsNeededSection'
import ApplicationOverview from './ApplicationOverview'
import InviteCollaboratorsSection from './InviteCollaboratorsSection'
import styles from './styles.module.scss'

const ApplicationDetailsTabContent = () => {
  const [getClassName, makeTestId] = useNameFormatter('ApplicationDetailsTabContent')

  const { appId } = useParams()
  const { data } = useGetCreditApplicationDetailsSuspenseQuery({
    variables: {
      creditApplicationId: appId ?? '',
    },
  })

  const { creditApplication } = data ?? {}
  const { applicationActionItems, statusCategory } = creditApplication ?? {}

  const hideInviteCollaborators =
    !statusCategory ||
    (statusCategory &&
      [StatusCategory.DECLINED, StatusCategory.EXPIRED, StatusCategory.ACCOUNT_CREATED].includes(statusCategory)) ||
    applicationActionItems?.some(({ action }) => action === 'create_password' || action === 'refresh_application')

  if (!creditApplication) {
    return null
  }

  return (
    <div
      className={styles[getClassName('')]}
      data-testid={makeTestId('')}
    >
      <ActionsNeededSection creditApplication={creditApplication} />
      <ApplicationOverview creditApplication={creditApplication} />
      <Divider className={styles[getClassName('divider')]} />
      {!hideInviteCollaborators && <InviteCollaboratorsSection salesforceCreditId={appId ?? ''} />}
    </div>
  )
}

export default ApplicationDetailsTabContent
